import type {
  Source,
  NightscoutSource,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { SourceType } from "@tandemdiabetes/sugarmate-api-react-client"
import { useSources } from "./useSources"

// returns the first nightscout source found in the sources array or undefined
export function useNightscoutSource(): NightscoutSource | undefined {
  const { data: sources } = useSources()
  if (!sources) {
    return undefined
  }

  return sources.find(
    (source: Source) => source.source_type === SourceType.Nightscout,
  ) as NightscoutSource
}
